(function () {
    'use strict';

    angular.module('handbookApp')
        .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', routesConfig]);

    function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.hashPrefix('!');
        $locationProvider.html5Mode(true);
        var internalPaths = window.paths;

		var templateUrlFieldView = internalPaths.DocumentFields;
		var controllerFieldView = 'DocumentFieldsController';

		if (parseInt(HandbookConfiguration.DocumentViewOption) == 2) {
			templateUrlFieldView = '/Document/fieldsContentWholeDocument';
			controllerFieldView = 'FieldsContentWholeDocumentController';
		}

        // Now set up the states
        $stateProvider
            .state('tab', {
                url: '/tab',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            })
            .state(handbookActions.DocumentAction, {
                url: handbookActionParameters.DocumentActionParameters,
                templateUrl: internalPaths.DocumentHome,
                controller: 'DocumentController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Document,
                    description: globalResources.DocumentMetaDescription
                }
            })
            .state(handbookActions.DocumentFromFieldViewAction, {
                url: handbookActionParameters.DocumentFromFieldViewActionParameters,
                templateUrl: internalPaths.DocumentHome,
                controller: 'DocumentController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Document,
                    description: globalResources.DocumentMetaDescription
                }
            })
            .state(handbookActions.HearingAction, {
                url: '/document/:documentId/hearing',
                templateUrl: '/Document/HearingFeedback',
                controller: 'HearingFeedbackController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Document,
                    description: globalResources.DocumentMetaDescription
                }
            })
            .state('hearingFieldsContent', {
                url: '/document/:documentId/hearingfields/:fieldId',
                templateUrl: '/Document/HearingFieldsContent',
                controller: 'DocumentHearingFieldsController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Document,
                    description: globalResources.DocumentMetaDescription
                }
            })
            .state('hearingCompareWithEarlierVersion', {
                url: '/documenthearing/:documentId/compareWithEarlierVersion',
                templateUrl: '/Document/CompareWithEarlierVersion',
                controller: 'CompareWithEarlierVersionController',
				controllerAs: 'vm',
                data: {
                    title: globalResources.Document,
                    description: globalResources.DocumentMetaDescription
                }
			})
			.state('compareWithEarlierVersion', {
				url: '/document/:documentId/compareWithEarlierVersion',
				templateUrl: '/Document/DocumentCompareWithEarlierVersion',
				controller: 'DocumentCompareWithEarlierVersionController',
				controllerAs: 'vm',
				data: {
					title: globalResources.Document,
					description: globalResources.DocumentMetaDescription
				}
			})
            .state(handbookActions.FolderAction, {
                url: handbookActionParameters.FolderActionParameters,
                templateUrl: internalPaths.ChapterHome,
                controller: 'chapterController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Folder,
                    description: globalResources.FolderMetaDescription
                }
            })
            .state(handbookActions.HomeAction, {
                url: handbookActionParameters.HomeActionParameters,
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            })
            .state(handbookActions.SearchResultAction, {
                url: handbookActionParameters.SearchResultActionParameters,
                templateUrl: internalPaths.ChapterSearch,
                controller: 'searchController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Search,
                    description: globalResources.SearchMetaDescription
                }
            })
            .state(handbookActions.DocumentFieldsAction, {
                url: '/document/:documentId/fields/:fieldId',
				templateUrl: templateUrlFieldView,
				controller: controllerFieldView,
                controllerAs: 'vm',
                data: {
                    title: globalResources.Document,
                    description: globalResources.DocumentMetaDescription
                }
            })
            .state(handbookActions.StartpageNews, {
                url: handbookActionParameters.StartpageNewsParameters,
                templateUrl: internalPaths.NewsDetais,
                controller: 'NewsDetailsController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            }).state(handbookActions.UnsupportBrowser, {
                url: '/unsupportedBrowser',
                templateUrl: '/app/components/home/templates/unsupportedBrowser.html',
                controller: 'homeController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            }).state(handbookActions.MyReadingReceiptsReport, {
                url: "/myReadingReceipts/params?folderId&recursive",
                templateUrl: '/app/components/home/templates/reportsView.html',
                controller: 'reportsViewController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            }).state(handbookActions.MyReadingListsReport, {
                url: "/myReadingLists",
                templateUrl: '/app/components/home/templates/reportsMyReadingListView.html',
                controller: 'reportsMyReadingListViewController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            }).state(handbookActions.NewsListAction, {
                url: '/newsList/:pageIndex',
                params: {
                    pageIndex: 1
                },
                templateUrl: '/app/components/home/view/newsList.html',
                controller: 'NewsListController',
                controllerAs: 'vm',
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            }).state(handbookActions.NewsCategoryAction, {
                url: '/newscategory/:categoryId',
                templateUrl: '/app/components/home/view/newsCategory.html',
                controller: 'NewsCategoryController',
                controllerAs: 'vm',
                params: {
                    categoryId: '',
                    pageIndex: '1'
                },
                data: {
                    title: globalResources.Home,
                    description: globalResources.HomeMetaDescription
                }
            }).state('embedDocument', {
                url: '/embed/document/:documentId',
                templateUrl: internalPaths.DocumentHome,
                controller: 'DocumentController',
                controllerAs: 'vm',
                data: {
                    title: '',
                    description: ''
                }
            }).state('embedDocumentField', {
                url: '/embed/document/:documentId/field/:fieldId/:type',
                templateUrl: internalPaths.DocumentFields,
                controller: 'DocumentFieldsController',
                controllerAs: 'vm',
                params: {
                    type: 0
                },
                data: {
                    title: '',
                    description: ''
                }
            }).state('embedDocumentField1', {
                url: '/embed/document/:documentId/field/:fieldId',
                templateUrl: internalPaths.DocumentFields,
                controller: 'DocumentFieldsController',
                controllerAs: 'vm',
                params: {
                    type: 0
                },
                data: {
                    title: '',
                    description: ''
                }
            }).state('annualCycleDetail', {
                url: '/annualCycle/:id',
                templateUrl: '/app/components/annualCycle/annualCycleDetail.html',
                controller: 'annualCycleDetailController',
                controllerAs: 'vm',
                params: {
                    id: ''
                },
                data: {
                    title: globalResources.AnnualCycle,
                    description: ''
                }
            })

        $urlRouterProvider.otherwise(handbookActionParameters.HomeActionParameters);
    };

    angular.module('handbookApp').run(['$rootScope', '$location', '$timeout', 'anchorService', 'documentService', 'broadcastService',
        function ($rootScope, $location, $timeout, anchorService, documentService, broadcastService) {
            $rootScope.$on('$locationChangeSuccess', function () {
                $rootScope.actualLocation = $location.absUrl();
			});
			$rootScope.$on('$locationChangeStart', function (event, next, current) {
				if (next && next.indexOf('fields') > 0) {
					$location.$$absUrl = decodeURIComponent($location.$$absUrl);
					var indexHash = $location.$$absUrl.indexOf('#');
					if (indexHash > 0 && !$location.$$hash) {
						var length = $location.$$absUrl.length - (indexHash + 1);
						$location.$$hash = $location.$$absUrl.substr(indexHash + 1, length);
					}
					$location.$$url = decodeURIComponent($location.$$url);
				}
			});
            $rootScope.$watch(function () { return $location.absUrl() }, function (newLocation, oldLocation) {
                var isBackButton = false;
                if ($rootScope.actualLocation === newLocation) {
                    isBackButton = true;
                }
                if ($location.hash() == null || $location.hash() == '') {
                    $timeout(function () {
                        var documentContent = angular.element('#document-content-identifier'),
                            folderContent = angular.element('#folder-content-identifier'),
                            newsContent = angular.element('#wrapper');
                        var anchorOject = anchorService.getAnchorObject();
                        var position = (anchorOject != null && isBackButton) ? anchorOject.position : 0;
                        if (documentContent && documentContent.length > 0) {
                            documentContent[0].scrollTop = position;
                        } else if (folderContent && folderContent.length > 0) {
                            folderContent[0].scrollTop = position;
                        } else if (newsContent && newsContent.length > 0) {
                            newsContent[0].scrollTop = position;
                        }
                        anchorService.setAnchorObject(0);
                    }, 100);
                }
                if (isBackButton) {
                    if (angular.element('#handbook-nav:visible').length == 0) {
                        documentService.showNormal();
                        broadcastService(broadcastType.toggleDocumentFullscreen, {});
                    }
                }
                if (!newLocation.includes(oldLocation) && !oldLocation.includes(newLocation)) {
                    angular.element('#treeDocuments span').removeClass('selected');
                }
            });

            $rootScope.$on('$stateChangeSuccess', function (event, toState) {

                // Sets the layout name, which can be used to display different layouts (header, footer etc.)
                // based on which page the user is located
                $rootScope.layout = toState.layout;
                $rootScope.title = globalResources.Handbook + " - " + toState.data.title;
                $rootScope.metaDescription = toState.data.description;
            });
        }]);
})();